import VSubheader from './VSubheader'

export { VSubheader }
export default VSubheader



// WEBPACK FOOTER //
// ../../../src/components/VSubheader/index.ts